// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__6fhAO","banner_tips":"Banner_banner_tips__TR6uO"};